<template>
  <div class="timeline-item">
    <div class="left-area">
      <div class="item-content">
        <slot name="left"></slot>
      </div>
      
    </div>
    <div class="right-area">
      <div class="item-content">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TimelineItem',
  data(){
    return {}
  }
}
</script>
<style lang="scss" scoped>
  .timeline-item {
    position: relative;
    display: flex;
    
  }
  .right-area,
  .left-area {
    margin: 0 20px;
    flex: 1;
    overflow: hidden;
    
    
  }
  .left-area  {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .right-area {
    color: #fff;
    font-weight: bold;
    font-size: 88px;
    text-align: left;
    line-height: 1;
     display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  
</style>

